import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { half } = measures

export const controlsWrapper = css`
  text-align: left;
  height: ${12 * half}px;
`
